import { APIScope, FMSType, LocationScope, LocationVarKey } from "@swivl-mono/types";

import { RouterWorksheetData } from "../../Components/Worksheets/Types/Worksheet.Interface";
import { IF_ALL, IF_ANY, IS_EQUAL, IS_NOT_EQUAL, IS_TRUE } from "../../Components/Worksheets/Types/Worksheet.Interface";
import AccountBalance, { PAGE_KEYS as AccountBalanceKeys } from "./Pages/Cortex.AccountBalance";
import AccountBillingDispute, { PAGE_KEYS as AccountBillingDisputeKeys } from "./Pages/Cortex.AccountBillingDispute";
import AccountNumber, { PAGE_KEYS as AccountNumberKeys } from "./Pages/Cortex.AccountNumber";
import AccountStatus, { PAGE_KEYS as AccountStatusKeys } from "./Pages/Cortex.AccountStatus";
import AdminFee, { PAGE_KEYS as AdminFeeKeys } from "./Pages/Cortex.AdminFee";
import AfterHourAccess, { PAGE_KEYS as AfterHourAccessKeys } from "./Pages/Cortex.AfterHourAccess";
import AgentQuickReply, { PAGE_KEYS as AgentQuickReplyKeys } from "./Pages/Cortex.AgentQuickReply";
import Auction, { PAGE_KEYS as AuctionKeys } from "./Pages/Cortex.Auction";
import AutoPay, { PAGE_KEYS as AutoPayKeys } from "./Pages/Cortex.AutoPay";
import BillingDispute, { PAGE_KEYS as BillingDisputeKeys } from "./Pages/Cortex.BillingDispute";
import BoatStorage, { PAGE_KEYS as BoatStorageKeys } from "./Pages/Cortex.BoatStorage";
import CTAMessage, { PAGE_KEYS as CTAMessageKeys } from "./Pages/Cortex.CTAMessage";
import CancelService, { PAGE_KEYS as CancelServiceKeys } from "./Pages/Cortex.CancelService";
import Cancellation, { PAGE_KEYS as CancellationKeys } from "./Pages/Cortex.Cancellation";
import Careers, { PAGE_KEYS as CareersKeys } from "./Pages/Cortex.Careers";
import ChangeDueDate, { PAGE_KEYS as ChangeDueDateKeys } from "./Pages/Cortex.ChangeDueDate";
import Claim, { PAGE_KEYS as ClaimKeys } from "./Pages/Cortex.Claim";
import ClimateControl, { PAGE_KEYS as ClimateControlKeys } from "./Pages/Cortex.ClimateControl";
import ContractLengths, { PAGE_KEYS as ContractLengthsKeys } from "./Pages/Cortex.ContractLengths";
import Covid, { PAGE_KEYS as CovidKeys } from "./Pages/Cortex.Covid";
import CreateLogin, { PAGE_KEYS as CreateLoginKeys } from "./Pages/Cortex.CreateLogin";
import CreditCardFee, { PAGE_KEYS as CreditCardFeeKeys } from "./Pages/Cortex.CreditCardFee";
import CronReviewSolicitations, { PAGE_KEYS as CronReviewSolicitationsKeys } from "./Pages/Cortex.CronReviewSolicitations";
import CutLocks, { PAGE_KEYS as CutLocksKeys } from "./Pages/Cortex.CutLocks";
import DamagedItems, { PAGE_KEYS as DamagedItemsKeys } from "./Pages/Cortex.DamagedItems";
import Discounts, { PAGE_KEYS as DiscountsKeys } from "./Pages/Cortex.Discounts";
import Dollies, { PAGE_KEYS as DolliesKeys } from "./Pages/Cortex.Dollies";
import DriveUp, { PAGE_KEYS as DriveUpKeys } from "./Pages/Cortex.DriveUp";
import DumpStation, { PAGE_KEYS as DumpStationKeys } from "./Pages/Cortex.DumpStation";
import Emergency, { PAGE_KEYS as EmergencyKeys } from "./Pages/Cortex.Emergency";
import EscalationSettings, { PAGE_KEYS as EscalationSettingsKeys } from "./Pages/Cortex.EscalationSettings";
import FacilityAccess, { PAGE_KEYS as FacilityAccessKeys } from "./Pages/Cortex.FacilityAccess";
import ForgotUsername, { PAGE_KEYS as ForgotUsernameKeys } from "./Pages/Cortex.ForgotUsername";
import Franchise, { PAGE_KEYS as FranchiseKeys } from "./Pages/Cortex.Franchise";
import GateCode, { PAGE_KEYS as GateCodeKeys } from "./Pages/Cortex.GateCode";
import GetLease, { PAGE_KEYS as GetLeaseKeys } from "./Pages/Cortex.GetLease";
import GetOut, { PAGE_KEYS as GetOutKeys } from "./Pages/Cortex.GetOut";
import GoogleReviewReceipts, { PAGE_KEYS as GoogleReviewReceiptsKeys } from "./Pages/Cortex.GoogleReviewReceipts";
import GracePeriod, { PAGE_KEYS as GracePeriodKeys } from "./Pages/Cortex.GracePeriod";
import HoldUnit, { PAGE_KEYS as HoldUnitKeys } from "./Pages/Cortex.HoldUnit";
import Identification, { PAGE_KEYS as IdentificationKeys } from "./Pages/Cortex.Identification";
import Insurance, { PAGE_KEYS as InsuranceKeys } from "./Pages/Cortex.Insurance";
import InsuranceCost, { PAGE_KEYS as InsuranceCostKeys } from "./Pages/Cortex.InsuranceCost";
import KeyAccess, { PAGE_KEYS as KeyAccessKeys } from "./Pages/Cortex.KeyAccess";
import LateFee, { PAGE_KEYS as LateFeeKeys } from "./Pages/Cortex.LateFee";
import LeadSettings, { PAGE_KEYS as LeadSettingsKeys } from "./Pages/Cortex.LeadSettings";
import Lights, { PAGE_KEYS as LightsKeys } from "./Pages/Cortex.Lights";
import LiveInUnit, { PAGE_KEYS as LiveInUnitKeys } from "./Pages/Cortex.LiveInUnit";
import LostKey, { PAGE_KEYS as LostKeyKeys } from "./Pages/Cortex.LostKey";
import MaintenancePest, { PAGE_KEYS as MaintenancePestKeys } from "./Pages/Cortex.MaintenancePest";
import ManageInsurance, { PAGE_KEYS as ManageInsuranceKeys } from "./Pages/Cortex.ManageInsurance";
import MobileApp, { PAGE_KEYS as MobileAppKeys } from "./Pages/Cortex.MobileApp";
import MonthlyPayments, { PAGE_KEYS as MonthlyPaymentsKeys } from "./Pages/Cortex.MonthlyPayments";
import MoveOutPolicy, { PAGE_KEYS as MoveOutPolicyKeys } from "./Pages/Cortex.MoveOutPolicy";
import MovingServices, { PAGE_KEYS as MovingServicesKeys } from "./Pages/Cortex.MovingServices";
import MovingTruck, { PAGE_KEYS as MovingTruckKeys } from "./Pages/Cortex.MovingTruck";
import MultipleAccounts, { PAGE_KEYS as MultipleAccountsKeys } from "./Pages/Cortex.MultipleAccounts";
import OutdoorParking, { PAGE_KEYS as OutdoorParkingKeys } from "./Pages/Cortex.OutdoorParking";
import Overlock, { PAGE_KEYS as OverlockKeys } from "./Pages/Cortex.Overlock";
import POMailbox, { PAGE_KEYS as POMailboxKeys } from "./Pages/Cortex.POMailbox";
import PackingSupplies, { PAGE_KEYS as PackingSuppliesKeys } from "./Pages/Cortex.PackingSupplies";
import PadlockAccess, { PAGE_KEYS as PadlockAccessKeys } from "./Pages/Cortex.PadlockAccess";
import PartialPayment, { PAGE_KEYS as PartialPaymentKeys } from "./Pages/Cortex.PartialPayment";
import PastDue, { PAGE_KEYS as PastDueKeys } from "./Pages/Cortex.PastDue";
import PayBill, { PAGE_KEYS as PayBillKeys } from "./Pages/Cortex.PayBill";
import PayOnline, { PAGE_KEYS as PayOnlineKeys } from "./Pages/Cortex.PayOnline";
import PaymentExtension, { PAGE_KEYS as PaymentExtensionKeys } from "./Pages/Cortex.PaymentExtension";
import PaymentHistory, { PAGE_KEYS as PaymentHistoryKeys } from "./Pages/Cortex.PaymentHistory";
import PaymentIssue, { PAGE_KEYS as PaymentIssueKeys } from "./Pages/Cortex.PaymentIssue";
import PaymentOptions, { PAGE_KEYS as PaymentOptionsKeys } from "./Pages/Cortex.PaymentOptions";
import PortableUnits from "./Pages/Cortex.PortableUnits";
import Pricing, { PAGE_KEYS as PricingKeys } from "./Pages/Cortex.Pricing";
import ProfileCancel, { PAGE_KEYS as ProfileCancelKeys } from "./Pages/Cortex.ProfileCancel";
import ProfileEscalationBot, { PAGE_KEYS as ProfileEscalationBotKeys } from "./Pages/Cortex.ProfileEscalationBot";
import ProfileEscalationCustomer, { PAGE_KEYS as ProfileEscalationCustomerKeys } from "./Pages/Cortex.ProfileEscalationCustomer";
import ProfileShopping, { PAGE_KEYS as ProfileShoppingKeys } from "./Pages/Cortex.ProfileShopping";
import ProfileWaitlist, { PAGE_KEYS as ProfileWaitlistKeys } from "./Pages/Cortex.ProfileWaitlist";
import ProfileWelcome, { PAGE_KEYS as ProfileWelcomeKeys } from "./Pages/Cortex.ProfileWelcome";
import ProfileWelcomeBack, { PAGE_KEYS as ProfileWelcomeBackKeys } from "./Pages/Cortex.ProfileWelcomeBack";
import ProfileWhatElse, { PAGE_KEYS as ProfileWhatElseKeys } from "./Pages/Cortex.ProfileWhatElse";
import Propane, { PAGE_KEYS as PropaneKeys } from "./Pages/Cortex.Propane";
import Prorate, { PAGE_KEYS as ProrateKeys } from "./Pages/Cortex.Prorate";
import RVParking, { PAGE_KEYS as RVParkingKeys } from "./Pages/Cortex.RVParking";
import RVParkingCovered, { PAGE_KEYS as RVParkingCoveredKeys } from "./Pages/Cortex.RVParkingCovered";
import RVParkingEnclosed, { PAGE_KEYS as RVParkingEnclosedKeys } from "./Pages/Cortex.RVParkingEnclosed";
import RateIncrease, { PAGE_KEYS as RateIncreaseKeys } from "./Pages/Cortex.RateIncrease";
import Referral, { PAGE_KEYS as ReferralKeys } from "./Pages/Cortex.Referral";
import Refunds, { PAGE_KEYS as RefundsKeys } from "./Pages/Cortex.Refunds";
import Reservation, { PAGE_KEYS as ReservationKeys } from "./Pages/Cortex.Reservation";
import ResetPassword, { PAGE_KEYS as ResetPasswordKeys } from "./Pages/Cortex.ResetPassword";
import ReviewReply, { PAGE_KEYS as ReviewReplyKeys } from "./Pages/Cortex.ReviewReply";
import SMSSettings, { PAGE_KEYS as SMSSettingsKeys } from "./Pages/Cortex.SMSSettings";
import Security, { PAGE_KEYS as SecurityKeys } from "./Pages/Cortex.Security";
import ShowInventory, { PAGE_KEYS as ShowInventoryKeys } from "./Pages/Cortex.ShowInventory";
import SizeDescriptions, { PAGE_KEYS as SizeDescriptionsKeys } from "./Pages/Cortex.SizeDescriptions";
import SizeVisuals, { PAGE_KEYS as SizeVisualsKeys } from "./Pages/Cortex.SizeVisuals";
import StandardCeilingHeight, { PAGE_KEYS as StandardCeilingHeightKeys } from "./Pages/Cortex.StandardCeilingHeight";
import StorableItems, { PAGE_KEYS as StorableItemsKeys } from "./Pages/Cortex.StorableItems";
import Theft, { PAGE_KEYS as TheftKeys } from "./Pages/Cortex.Theft";
import Tour, { PAGE_KEYS as TourKeys } from "./Pages/Cortex.Tour";
import UnitNumber, { PAGE_KEYS as UnitNumberKeys } from "./Pages/Cortex.UnitNumber";
import UnitSize, { PAGE_KEYS as UnitSizeKeys } from "./Pages/Cortex.UnitSize";
import UnitTransfer, { PAGE_KEYS as UnitTransferKeys } from "./Pages/Cortex.UnitTransfer";
import UpdateBillingInformation, { PAGE_KEYS as UpdateBillingInformationKeys } from "./Pages/Cortex.UpdateBillingInformation";
import UpdateContactInformation, { PAGE_KEYS as UpdateContactInformationKeys } from "./Pages/Cortex.UpdateContactInformation";
import ValueBasedPricing, { PAGE_KEYS as ValueBasedPricingKeys } from "./Pages/Cortex.ValueBasedPricing";
import VehicleStorage, { PAGE_KEYS as VehicleStorageKeys } from "./Pages/Cortex.VehicleStorage";
import VehicleStorageCovered, { PAGE_KEYS as VehicleStorageCoveredKeys } from "./Pages/Cortex.VehicleStorageCovered";
import VehicleStorageGuidelines, { PAGE_KEYS as VehicleStorageGuidelinesKeys } from "./Pages/Cortex.VehicleStorageGuidelines";
import VehicleStorageIndoor, { PAGE_KEYS as VehicleStorageIndoorKeys } from "./Pages/Cortex.VehicleStorageIndoor";
import WebIssue, { PAGE_KEYS as WebIssueKeys } from "./Pages/Cortex.WebIssue";
import WebRates, { PAGE_KEYS as WebRatesKeys } from "./Pages/Cortex.WebRates";
import WineStorage, { PAGE_KEYS as WineStorageKeys } from "./Pages/Cortex.WineStorage";
import WorkInUnit, { PAGE_KEYS as WorkInUnitKeys } from "./Pages/Cortex.WorkInUnit";
import SequencesAbandonedCart, { PAGE_KEYS as SequencesAbandonedCartKeys } from "./Pages/Sequences/Cortex.SequencesAbandonedCart";
import SequencesMoveIn, { PAGE_KEYS as SequencesMoveInKeys } from "./Pages/Sequences/Cortex.SequencesMoveIn";
import SequencesMoveOut, { PAGE_KEYS as SequencesMoveOutKeys } from "./Pages/Sequences/Cortex.SequencesMoveOut";
import SequencesPastDue, { PAGE_KEYS as SequencesPastDueKeys } from "./Pages/Sequences/Cortex.SequencesPastDue";
import VoiceAccountBalance, { PAGE_KEYS as VoiceAccountBalanceKeys } from "./Pages/Voice/Cortex.VoiceAccountBalance";
import VoiceAccountNumber, { PAGE_KEYS as VoiceAccountNumberKeys } from "./Pages/Voice/Cortex.VoiceAccountNumber";
import VoiceAfterHoursEmergency, { PAGE_KEYS as VoiceAfterHoursEmergencyKeys } from "./Pages/Voice/Cortex.VoiceAfterHoursEmergency";
import VoiceAutopay, { PAGE_KEYS as VoiceAutopayKeys } from "./Pages/Voice/Cortex.VoiceAutopay";
import VoiceCancel, { PAGE_KEYS as VoiceCancelKeys } from "./Pages/Voice/Cortex.VoiceCancel";
import VoiceEditAccountInfo, { PAGE_KEYS as VoiceEditAccountInfoKeys } from "./Pages/Voice/Cortex.VoiceEditAccountInfo";
import VoiceGateCode, { PAGE_KEYS as VoiceGateCodeKeys } from "./Pages/Voice/Cortex.VoiceGateCode";
import VoiceGetLease, { PAGE_KEYS as VoiceGetLeaseKeys } from "./Pages/Voice/Cortex.VoiceGetLease";
import VoiceLoginIssues, { PAGE_KEYS as VoiceLoginIssuesKeys } from "./Pages/Voice/Cortex.VoiceLoginIssues";
import VoiceManageInsurance, { PAGE_KEYS as VoiceManageInsuranceKeys } from "./Pages/Voice/Cortex.VoiceManageInsurance";
import VoicePayBill, { PAGE_KEYS as VoicePayBillKeys } from "./Pages/Voice/Cortex.VoicePayBill";
import VoicePaymentHistory, { PAGE_KEYS as VoicePaymentHistoryKeys } from "./Pages/Voice/Cortex.VoicePaymentHistory";
import VoiceRentAUnit, { PAGE_KEYS as VoiceRentAUnitKeys } from "./Pages/Voice/Cortex.VoiceRentAUnit";
import VoiceSettings, { PAGE_KEYS as VoiceSettingsKeys } from "./Pages/Voice/Cortex.VoiceSettings";
import SpotReferrals, { PAGE_KEYS as SpotReferralsKeys } from "./Pages/spot/Cortex.SpotReferrals";
import SpotReview, { PAGE_KEYS as SpotReviewKeys } from "./Pages/spot/Cortex.SpotReview";

const All: RouterWorksheetData[] = [
  {
    to: `access`,
    label: "Access",
    children: [
      {
        to: `after-hours`,
        label: "After Hours Access",
        hideIf: IS_NOT_EQUAL(LocationVarKey.HasAfterHoursAccess, "1"),
        element: <AfterHourAccess />,
        keys: AfterHourAccessKeys
      },
      { to: `gate-code`, label: "Gate Code", element: <GateCode />, keys: GateCodeKeys },
      { to: `key-access`, label: "Key Access", element: <KeyAccess />, keys: KeyAccessKeys },
      {
        to: `padlock-access`,
        label: "Padlock / DaVinci Access",
        hideIf: IS_NOT_EQUAL(LocationVarKey.HasPadlocks, "1"),
        element: <PadlockAccess />,
        keys: PadlockAccessKeys
      },
      { to: `tour`, label: "Tour", element: <Tour />, keys: TourKeys },
      { to: `unit-number`, label: "Unit Number", element: <UnitNumber />, keys: UnitNumberKeys }
    ]
  },
  {
    to: `account-management`,
    label: "Account Management",
    children: [
      { to: `auto-pay`, label: "Autopay", element: <AutoPay />, keys: AutoPayKeys },
      { to: `account-status`, label: "Account Status", element: <AccountStatus />, keys: AccountStatusKeys },
      { to: `account-balance`, label: "Account Balance", element: <AccountBalance />, keys: AccountBalanceKeys },
      {
        to: `account-number`,
        label: "Account Number",
        hideIf: IS_NOT_EQUAL(LocationVarKey.FMSType, FMSType.StorEdge),
        element: <AccountNumber />,
        keys: AccountNumberKeys
      },
      { to: `billing-dispute`, label: "Billing Dispute", element: <AccountBillingDispute />, keys: AccountBillingDisputeKeys },
      { to: `cancel-service`, label: "Cancel Service", element: <CancelService />, keys: CancelServiceKeys },
      { to: `create-login`, label: "Create Login", element: <CreateLogin />, keys: CreateLoginKeys },
      { to: `due-date`, label: "Due Date", element: <ChangeDueDate />, keys: ChangeDueDateKeys },
      { to: `forgot-username`, label: "Forgot Username", element: <ForgotUsername />, keys: ForgotUsernameKeys },
      { to: `grace-period`, label: "Grace Period", element: <GracePeriod />, keys: GracePeriodKeys },
      { to: `hold-unit`, label: "Hold Unit", element: <HoldUnit />, keys: HoldUnitKeys },
      { to: `manage-insurance`, label: "Manage Insurance", element: <ManageInsurance />, keys: ManageInsuranceKeys },
      { to: `multiple-accounts`, label: "Multiple Accounts", element: <MultipleAccounts />, keys: MultipleAccountsKeys },
      { to: `partial-payment`, label: "Partial Payment", element: <PartialPayment />, keys: PartialPaymentKeys },
      { to: `past-due`, label: "Past Due", element: <PastDue />, keys: PastDueKeys },
      { to: `pay-bill`, label: "Pay Bill", element: <PayBill />, keys: PayBillKeys },
      { to: `payment-extension`, label: "Payment Extension", element: <PaymentExtension />, keys: PaymentExtensionKeys },
      { to: `payment-history`, label: "Payment History", element: <PaymentHistory />, keys: PaymentHistoryKeys },
      { to: `reservation`, label: "Reservation", element: <Reservation />, keys: ReservationKeys },
      { to: `reset-password`, label: "Reset Password", element: <ResetPassword />, keys: ResetPasswordKeys },
      { to: `unit-size`, label: "Unit Size", element: <UnitSize />, keys: UnitSizeKeys },
      { to: `update-billing`, label: "Update Billing Info", element: <UpdateBillingInformation />, keys: UpdateBillingInformationKeys },
      { to: `update-contact-info`, label: "Update Contact Info", element: <UpdateContactInformation />, keys: UpdateContactInformationKeys }
    ]
  },
  {
    to: `customer-profile`,
    label: "Customer Profile",
    children: [
      { to: `escalation-bot`, label: "Bot Escalation", element: <ProfileEscalationBot />, keys: ProfileEscalationBotKeys },
      { to: `cancel`, label: "Cancel", element: <ProfileCancel />, keys: ProfileCancelKeys },
      {
        to: `escalation-customer`,
        label: "Customer Escalation",
        hideIf: IS_NOT_EQUAL(LocationVarKey.WantsCustomerInitiatedEscalations, "1"),
        element: <ProfileEscalationCustomer />,
        keys: ProfileEscalationCustomerKeys
      },
      { to: `lead-settings`, label: "Leads", element: <LeadSettings />, keys: LeadSettingsKeys },
      { to: `shopping`, label: "Shopping", element: <ProfileShopping />, keys: ProfileShoppingKeys },
      { to: `waitlist`, label: "Waitlist", element: <ProfileWaitlist />, keys: ProfileWaitlistKeys },
      { to: `welcome`, label: "Welcome", element: <ProfileWelcome />, keys: ProfileWelcomeKeys },
      { to: `welcome-back`, label: "Welcome Back", element: <ProfileWelcomeBack />, keys: ProfileWelcomeBackKeys },
      { to: `what-else`, label: "What Else", element: <ProfileWhatElse />, keys: ProfileWhatElseKeys }
    ]
  },
  {
    to: `engagement`,
    label: "Engagement",
    hideIf: IF_ALL([
      IS_NOT_EQUAL(LocationVarKey.HasCustomCTAMessage, "1"),
      IS_NOT_EQUAL(LocationVarKey.HasLiveChat, "1"),
      IS_NOT_EQUAL(LocationVarKey.HasGoogleReviewIntegration, "1")
    ]),
    children: [
      {
        to: `custom-call-to-action`,
        label: "Call to Action",
        hideIf: IS_NOT_EQUAL(LocationVarKey.HasCustomCTAMessage, "1"),
        element: <CTAMessage />,
        keys: CTAMessageKeys
      },
      {
        to: `quickreplies-livechat`,
        label: "Quick Replies (Live Chat)",
        hideIf: IS_NOT_EQUAL(LocationVarKey.HasLiveChat, "1"),
        element: <AgentQuickReply />,
        keys: AgentQuickReplyKeys
      },
      {
        to: `quickreplies-reviews`,
        label: "Google Review Replies",
        hideIf: IS_NOT_EQUAL(LocationVarKey.HasGoogleReviewIntegration, "1"),
        element: <ReviewReply />,
        keys: ReviewReplyKeys
      }
      // { to: `google-review-receipts`, label: "Google Review Receipts", hideIf: IS_NOT_EQUAL(LocationVarKey.HasGoogleReviewIntegration, "1"), element: <GoogleReviewReceipts />, keys: GoogleReviewReceiptsKeys },
    ]
  },
  {
    to: `escalations`,
    label: "Escalations",
    children: [{ to: `escalations`, label: "Escalations", element: <EscalationSettings />, keys: EscalationSettingsKeys }]
  },
  {
    to: `features-amenities`,
    label: "Features & Amenities",
    children: [
      { to: `auctions`, label: "Auctions", hideIf: IS_NOT_EQUAL(LocationVarKey.HasAuctions, "1"), element: <Auction />, keys: AuctionKeys },
      { to: `careers`, label: "Careers", hideIf: IS_NOT_EQUAL(LocationVarKey.HasCareerURL, "1"), element: <Careers />, keys: CareersKeys },
      {
        to: `climate-control`,
        label: "Climate Control",
        hideIf: IS_NOT_EQUAL(LocationVarKey.HasClimateControlledUnits, "1"),
        element: <ClimateControl />,
        keys: ClimateControlKeys
      },
      { to: `dollies`, label: "Dollies", hideIf: IS_NOT_EQUAL(LocationVarKey.HasDollies, "1"), element: <Dollies />, keys: DolliesKeys },
      {
        to: `driveup-units`,
        label: "Drive-Up Units",
        hideIf: IS_NOT_EQUAL(LocationVarKey.HasDriveUpUnits, "1"),
        element: <DriveUp />,
        keys: DriveUpKeys
      },
      {
        to: `dump-station`,
        label: "Dump Station",
        hideIf: IS_NOT_EQUAL(LocationVarKey.HasDumpStation, "1"),
        element: <DumpStation />,
        keys: DumpStationKeys
      },
      { to: `franchise`, label: "Franchise", hideIf: IS_NOT_EQUAL(LocationVarKey.HasFranchise, "1"), element: <Franchise />, keys: FranchiseKeys },
      { to: `lights`, label: "Lights", element: <Lights />, keys: LightsKeys },
      { to: `maintenance`, label: "Maintenance/Pests", element: <MaintenancePest />, keys: MaintenancePestKeys },
      { to: `mobile-app`, label: "Mobile App", hideIf: IS_NOT_EQUAL(LocationVarKey.HasMobileApp, "1"), element: <MobileApp />, keys: MobileAppKeys },
      {
        to: `moving-services`,
        label: "Moving Services",
        hideIf: IS_NOT_EQUAL(LocationVarKey.HasMovingServices, "1"),
        element: <MovingServices />,
        keys: MovingServicesKeys
      },
      {
        to: `moving-truck`,
        label: "Moving Truck",
        hideIf: IS_NOT_EQUAL(LocationVarKey.HasMovingTrucks, "1"),
        element: <MovingTruck />,
        keys: MovingTruckKeys
      },
      {
        to: `packing-supplies`,
        label: "Packing Supplies",
        hideIf: IS_NOT_EQUAL(LocationVarKey.HasPackingSupplies, "1"),
        element: <PackingSupplies />,
        keys: PackingSuppliesKeys
      },
      { to: `propane`, label: "Propane", hideIf: IS_NOT_EQUAL(LocationVarKey.HasPropane, "1"), element: <Propane /> },
      { to: `portable-units`, label: "Portable Units", hideIf: IS_NOT_EQUAL(LocationVarKey.HasPortableUnits, "1"), element: <PortableUnits /> },
      { to: `security`, label: "Security", element: <Security /> },
      { to: `wine`, label: "Wine", hideIf: IS_NOT_EQUAL(LocationVarKey.HasWineStorage, "1"), element: <WineStorage /> }
    ]
  },
  {
    to: `issue-resolution`,
    label: "Issue Resolution",
    children: [
      { to: `billing-issue`, label: "Billing Issue", element: <BillingDispute />, keys: BillingDisputeKeys },
      { to: `damaged-items`, label: "Damaged Items", element: <DamagedItems />, keys: DamagedItemsKeys },
      { to: `emergency`, label: "Emergency", element: <Emergency />, keys: EmergencyKeys },
      { to: `get-out`, label: "Get Out", element: <GetOut />, keys: GetOutKeys },
      { to: `lost-key`, label: "Lost Key", element: <LostKey />, keys: LostKeyKeys },
      { to: `payment-issue`, label: "Payment Issue", element: <PaymentIssue />, keys: PaymentIssueKeys },
      { to: `theft`, label: "Theft", element: <Theft />, keys: TheftKeys },
      { to: `web-issues`, label: "Web Issues", element: <WebIssue />, keys: WebIssueKeys }
    ]
  },
  {
    to: `lease`,
    label: "Lease",
    children: [
      { to: `cancellation`, label: "Cancellation", element: <Cancellation />, keys: CancellationKeys },
      { to: `contract-lengths`, label: "Contract Lengths", element: <ContractLengths />, keys: ContractLengthsKeys },
      { to: `covid`, label: "Covid", element: <Covid />, keys: CovidKeys },
      { to: `cut-locks`, label: "Cut Locks", element: <CutLocks />, keys: CutLocksKeys },
      { to: `facility-access`, label: "Facility Access", element: <FacilityAccess />, keys: FacilityAccessKeys },
      { to: `file-claim`, label: "File A Claim", element: <Claim />, keys: ClaimKeys },
      { to: `get-lease`, label: "Get Lease", element: <GetLease />, keys: GetLeaseKeys },
      { to: `identification`, label: "Identification", element: <Identification />, keys: IdentificationKeys },
      { to: `insurance`, label: "Insurance", element: <Insurance />, keys: InsuranceKeys },
      { to: `live-in-unit`, label: "Live In Unit", element: <LiveInUnit />, keys: LiveInUnitKeys },
      { to: `monthly-pricing`, label: "Monthly Pricing", element: <MonthlyPayments />, keys: MonthlyPaymentsKeys },
      { to: `moveout-policy`, label: "Move Out Policy", element: <MoveOutPolicy />, keys: MoveOutPolicyKeys },
      { to: `overlock`, label: "Overlock", element: <Overlock />, keys: OverlockKeys },
      { to: `pay-online`, label: "Pay Online", element: <PayOnline />, keys: PayOnlineKeys },
      { to: `payment-options`, label: "Payment Options", element: <PaymentOptions />, keys: PaymentOptionsKeys },
      { to: `pricing`, label: "Pricing", element: <Pricing />, keys: PricingKeys },
      { to: `prorate`, label: "Prorate", element: <Prorate />, keys: ProrateKeys },
      { to: `refunds`, label: "Refunds", element: <Refunds />, keys: RefundsKeys },
      { to: `storable-items`, label: "Storable Items", element: <StorableItems />, keys: StorableItemsKeys },
      { to: `unit-transfer`, label: "Unit Transfer", element: <UnitTransfer />, keys: UnitTransferKeys },
      { to: `work-inUnit`, label: "Work In Unit", element: <WorkInUnit />, keys: WorkInUnitKeys }
    ]
  },
  {
    to: `parking-vehicles`,
    label: "Parking & Vehicles",
    hideIf: IF_ALL([
      IS_NOT_EQUAL(LocationVarKey.HasBoatStorage, "1"),
      IS_NOT_EQUAL(LocationVarKey.HasRVParking, "1"),
      IS_NOT_EQUAL(LocationVarKey.HasRVParkingCovered, "1"),
      IS_NOT_EQUAL(LocationVarKey.HasRVParkingEnclosed, "1"),
      IS_NOT_EQUAL(LocationVarKey.HasVehicleStorage, "1"),
      IS_NOT_EQUAL(LocationVarKey.HasCoveredVehicleStorage, "1"),
      IS_NOT_EQUAL(LocationVarKey.HasIndoorVehicleStorage, "1"),
      IS_NOT_EQUAL(LocationVarKey.HasOutdoorVehicleStorage, "1")
    ]),
    children: [
      {
        to: `boat`,
        label: "Boat Storage",
        hideIf: IS_NOT_EQUAL(LocationVarKey.HasBoatStorage, "1"),
        element: <BoatStorage />,
        keys: BoatStorageKeys
      },

      {
        to: `rv`,
        label: "RV Parking (General)",
        hideIf: IS_NOT_EQUAL(LocationVarKey.HasRVParking, "1"),
        element: <RVParking />,
        keys: RVParkingKeys
      },
      {
        to: `rv-covered`,
        label: "RV Parking Covered",
        hideIf: IF_ANY([IS_NOT_EQUAL(LocationVarKey.HasRVParking, "1"), IS_NOT_EQUAL(LocationVarKey.HasRVParkingCovered, "1")]),
        element: <RVParkingCovered />,
        keys: RVParkingCoveredKeys
      },
      {
        to: `rv-enclosed`,
        label: "RV Parking Enclosed",
        hideIf: IF_ANY([IS_NOT_EQUAL(LocationVarKey.HasRVParking, "1"), IS_NOT_EQUAL(LocationVarKey.HasRVParkingEnclosed, "1")]),
        element: <RVParkingEnclosed />,
        keys: RVParkingEnclosedKeys
      },

      {
        to: `vehicle-guidelines`,
        label: "Storage Guidelines",
        hideIf: IS_NOT_EQUAL(LocationVarKey.HasVehicleStorage, "1"),
        element: <VehicleStorageGuidelines />,
        keys: VehicleStorageGuidelinesKeys
      },
      {
        to: `vehicle-storage`,
        label: "Vehicle Storage (General)",
        hideIf: IS_NOT_EQUAL(LocationVarKey.HasVehicleStorage, "1"),
        element: <VehicleStorage />,
        keys: VehicleStorageKeys
      },
      {
        to: `covered`,
        label: "Vehicle Storage Covered",
        hideIf: IF_ANY([IS_NOT_EQUAL(LocationVarKey.HasVehicleStorage, "1"), IS_NOT_EQUAL(LocationVarKey.HasCoveredVehicleStorage, "1")]),
        element: <VehicleStorageCovered />,
        keys: VehicleStorageCoveredKeys
      },
      {
        to: `indoor`,
        label: "Vehicle Storage Indoor",
        hideIf: IF_ANY([IS_NOT_EQUAL(LocationVarKey.HasVehicleStorage, "1"), IS_NOT_EQUAL(LocationVarKey.HasIndoorVehicleStorage, "1")]),
        element: <VehicleStorageIndoor />,
        keys: VehicleStorageIndoorKeys
      },
      {
        to: `outdoor`,
        label: "Vehicle Storage Outdoor",
        hideIf: IF_ANY([IS_NOT_EQUAL(LocationVarKey.HasVehicleStorage, "1"), IS_NOT_EQUAL(LocationVarKey.HasOutdoorVehicleStorage, "1")]),
        element: <OutdoorParking />,
        keys: OutdoorParkingKeys
      }
    ]
  },
  {
    to: `pricing`,
    label: "Pricing",
    children: [
      { to: `admin-fee`, label: "Admin Fee", element: <AdminFee />, keys: AdminFeeKeys },
      { to: `credit-card-fee`, label: "Credit Card Fee", element: <CreditCardFee />, keys: CreditCardFeeKeys },
      { to: `discounts`, label: "Discounts", element: <Discounts />, keys: DiscountsKeys },
      { to: `insurance-cost`, label: "Insurance Cost", element: <InsuranceCost />, keys: InsuranceCostKeys },
      { to: `inventory`, label: "Show Inventory", element: <ShowInventory />, keys: ShowInventoryKeys },
      { to: `late-fee`, label: "Late Fee", element: <LateFee />, keys: LateFeeKeys },
      { to: `rate-increase`, label: "Rate Increase", element: <RateIncrease />, keys: RateIncreaseKeys },
      { to: `referral`, label: "Referral", element: <Referral />, keys: ReferralKeys },
      {
        to: `value-based-pricing`,
        label: "Value Based Pricing",
        hideIf: IS_NOT_EQUAL(LocationVarKey.HasValueBasedPricing, "1"),
        element: <ValueBasedPricing />,
        keys: ValueBasedPricingKeys
      },
      { to: `web-rates`, label: "Web Rates", element: <WebRates />, keys: WebRatesKeys }
    ]
  },
  {
    to: `sequences`,
    label: "Sequences",
    hideIf: IS_NOT_EQUAL(LocationVarKey.HasFMSPlus, "1"),
    children: [
      { to: `move-ins`, label: "Move Ins", element: <SequencesMoveIn />, keys: SequencesMoveInKeys },
      { to: `pastdue`, label: "Past Due Payments", element: <SequencesPastDue />, keys: SequencesPastDueKeys },
      { to: `move-outs`, label: "Move Outs", element: <SequencesMoveOut />, keys: SequencesMoveOutKeys },
      { to: `abandoned-cart`, label: "Abandoned Carts", element: <SequencesAbandonedCart />, keys: SequencesAbandonedCartKeys },

      { to: `review-solicitation`, label: "Review Solicitation", element: <CronReviewSolicitations />, keys: CronReviewSolicitationsKeys },
      { to: `sms-settings`, label: "SMS Settings", element: <SMSSettings />, keys: SMSSettingsKeys }
    ]
  },
  {
    to: "spot",
    label: "spot",
    children: [
      { to: "referral", label: "Referral", element: <SpotReferrals />, keys: SpotReferralsKeys },
      { to: "review", label: "Review", element: <SpotReview />, keys: SpotReviewKeys }
    ]
  },
  {
    to: `sizing`,
    label: "Sizing",
    children: [
      { to: `ceiling-height`, label: "Ceiling Height", element: <StandardCeilingHeight />, keys: StandardCeilingHeightKeys },
      { to: `descriptions`, label: "Size Descriptions", element: <SizeDescriptions />, keys: SizeDescriptionsKeys },
      {
        to: `po-mailbox`,
        label: "PO / Mail Boxes",
        hideIf: IS_NOT_EQUAL(LocationVarKey.HasPOMailbox, "1"),
        element: <POMailbox />,
        keys: POMailboxKeys
      },
      { to: `visuals`, label: "Size Visuals", element: <SizeVisuals />, keys: SizeVisualsKeys }
    ]
  },
  {
    to: `voice`,
    label: "Voice",
    hideIf: IS_NOT_EQUAL(LocationVarKey.swivlHasVoice, "1"),
    children: [
      { to: `voice-settings`, label: "Voice Settings", element: <VoiceSettings />, keys: VoiceSettingsKeys },
      { to: "voice-account-balance", label: "Account Balance", element: <VoiceAccountBalance />, keys: VoiceAccountBalanceKeys },
      {
        to: "voice-account-number",
        label: "Account Number",
        hideIf: IS_NOT_EQUAL(LocationVarKey.FMSType, FMSType.StorEdge),
        element: <VoiceAccountNumber />,
        keys: VoiceAccountNumberKeys
      },
      {
        to: "voice-after-hours-emergency",
        label: "After Hours Emergency",
        element: <VoiceAfterHoursEmergency />,
        keys: VoiceAfterHoursEmergencyKeys
      },
      { to: "voice-autopay", label: "Autopay", element: <VoiceAutopay />, keys: VoiceAutopayKeys },
      { to: `voice-cancel`, label: "Cancel", element: <VoiceCancel />, keys: VoiceCancelKeys },
      { to: `voice-gate-code`, label: "Gate Code", element: <VoiceGateCode />, keys: VoiceGateCodeKeys },
      { to: `voice-get-lease`, label: "Get Lease", element: <VoiceGetLease />, keys: VoiceGetLeaseKeys },
      { to: `voice-login-issues`, label: "Login Issues", element: <VoiceLoginIssues />, keys: VoiceLoginIssuesKeys },
      { to: "voice-manage-insurance", label: "Manage Insurance", element: <VoiceManageInsurance />, keys: VoiceManageInsuranceKeys },
      { to: "voice-payment-history", label: "Payment History", element: <VoicePaymentHistory />, keys: VoicePaymentHistoryKeys },
      { to: `voice-pay-bill`, label: "Pay Bill", element: <VoicePayBill />, keys: VoicePayBillKeys },
      { to: `voice-rent-a-unit`, label: "Rent a Unit", element: <VoiceRentAUnit />, keys: VoiceRentAUnitKeys },
      { to: `voice-edit-account-info`, label: "Update Account Info", element: <VoiceEditAccountInfo />, keys: VoiceEditAccountInfoKeys }
    ]
  }
];

export const CortexWorksheetsData = {
  [LocationScope.ORG]: All,
  [LocationScope.GROUP]: All,
  [LocationScope.LOCATION]: All
};
